import { Horario, HorarioForm, HorarioUpsert } from '@models/.';

export function transformToData(schedule: Horario | null): Horario | null {
  if (!schedule) return null;
  
  return {
    ...schedule,
  };
}

export function transformToForm(schedule: Horario | null ): HorarioForm | null {
  if (!schedule) return null;

  const {
    dia: day,
    apertura: opening,
    cierre: closing,
  } = schedule;
  
  return {
    day,
    opening,
    closing,
  };
}

export function transformArrayScheduleForm(schedules: Horario[] | null | undefined): HorarioForm[] {
  return (schedules ?? []).map((scheduleForm) => (transformToForm(scheduleForm)) as HorarioForm) ?? [];
}

export function transformToUpsert(
  scheduleForm: HorarioForm | null
): HorarioUpsert | null {
  if (!scheduleForm) return null;

  const {
    day,
    opening,
    closing,
  } = scheduleForm;

  return {
    day,
    opening,
    closing,
  };
}

export function transformArrayScheduleUpsert(schedulesForm: HorarioForm[] | null | undefined): HorarioUpsert[] {
  return (schedulesForm ?? []).map((scheduleForm) => (transformToUpsert(scheduleForm)) as HorarioUpsert) ?? [];
}
